<template>
  <div>
    <Navigation :is-mobile-filter="isMobileFilter" @icon-filter-clicked="handleIconFilterClicked"
      @icon-close-clicked="handleIconCloseClicked" :loggedIn="loggedIn" />
    <div id="pricingTableSmall">
      <v-data-table fixed-header height="100vh" :headers="headers" :items="pricing" :items-per-page="50" item-key="id"
        :search="search" mobile-breakpoint="0" ref="refName" :sort-by.sync="sortColumn"
        :sort-desc.sync="sortDesc" class="main-data-table">
        <template v-slot:top>
          <filter-bar :is-mobile-filter="isMobileFilter" v-on:searchTextEntered="handleSearch"
            v-on:sortChanged="handleSort" />
          <v-col class="desktop-filter-bar__search hidden-sm-and-up">
            <p class="desktop-filter-bar__input-label">Search companies</p>
            <div class="search-bar__search-input">
              <search-input :label="'Search companies'" class="search-bar__search-input-input"
                :placeholder-text="'Search Companies'" v-on:searchTextEntered="handleSearch" />
              <v-btn class="ml-3 search-bar__search-input-filter" outlined color="primary"
                @click="isMobileFilter = !isMobileFilter">
                <v-icon>mdi-filter-outline</v-icon>
              </v-btn>
            </div>
          </v-col>
        </template>

        <template v-slot:item.company.name="{ item }">
          <v-layout class="d-flex align-center">
            <v-img width="22" max-width="22" :src="'https://logo.clearbit.com/' + item.company.domain + ''"
              class="outlined"></v-img>
            <v-btn text class="pl-3 subtitle-2 text-capitalize text-left" @click.prevent="rowClick(item.company.name)">{{ item.company.name }}</v-btn>
          </v-layout>
        </template>
        <template v-slot:item.plan_name="{ item }">
          <div class="subtitle-2">{{ item.plan_name }}</div>
        </template>
        <template v-slot:item.default_price="{ item }">
          <div v-if="item.default_price !== null" class="subtitle-2">
            {{ currency[item.currency] }}{{ item.default_price }}
          </div>
          <div v-else class="no-value"></div>
        </template>
        <template v-slot:item.call_to_action="{ item }">
          <div v-if="item.call_to_action !== ''" class="subtitle-2">
            {{ item.call_to_action }}
          </div>
          <div v-else class="no-value"></div>
        </template>

        <template v-slot:item.default_period="{ item }">
          <div v-if="item.default_period != ''" class="subtitle-2">
            {{ getPeriod(item.default_period) }}
          </div>
          <div v-else class="no-value"></div>
        </template>
        <!-- <template v-slot:item.secondary_price="{ item }">
          <div v-if="item.secondary_price !== null" class="subtitle-2">
            {{ currency[item.currency] }}{{ item.secondary_price }}
          </div>
          <div v-else class="no-value"></div>
        </template> -->
        <!-- <template v-slot:item.secondary_period="{ item }">
          <v-chip
            class="uppercase"
            small
            outlined
            v-if="item.secondary_period != ''"
            >{{ getPeriod(item.secondary_period) }}</v-chip
          >
          <div v-else class="no-value"></div>
        </template> -->
        <template v-slot:item.currency="{ item }">
          <div class="subtitle-2">{{ item.currency }}</div>
        </template>
        <template v-slot:item.length_of_trial="{ item }">
          <v-chip class="uppercase" small dense v-if="item.length_of_trial != ''">{{ item.length_of_trial }}
            days</v-chip>
          <div v-else class="no-value"></div>
        </template>
        <template v-slot:item.trial_period="{ item }">
          <v-chip class="uppercase" small outlined v-if="item.trial_period != ''">{{ item.trial_period }}</v-chip>
          <div v-else class="no-value"></div>
        </template>
        <template v-slot:item.hero="{ item }">
          <div v-if="item.hero != 0" class="subtitle-2">
            Yes
          </div>
          <div v-else class="subtitle-2">No</div>
        </template>
        <template v-slot:item.enterprise="{ item }">
          <div v-if="item.enterprise != 0" class="subtitle-2">
            Yes
          </div>
          <div v-else class="subtitle-2">No</div>
        </template>
        <template v-slot:item.per_user_pricing="{ item }">
          <div v-if="item.per_user_pricing != 0" class="subtitle-2">
            Yes
          </div>
          <div v-else class="subtitle-2">No</div>
        </template>
        <template v-slot:item.sliding_scale_pricing="{ item }">
          <div v-if="item.sliding_scale_pricing != 0" class="subtitle-2">
            Yes
          </div>
          <div v-else class="subtitle-2">No</div>
        </template>
        <template v-slot:item.money_back_guarantee="{ item }">
          <div v-if="item.money_back_guarantee != 0" class="subtitle-2">
            Yes
          </div>
          <div v-else class="subtitle-2">No</div>
        </template>
      </v-data-table>
      <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="500">
          <v-card>
            <v-card-title class="headline">Analyze 1000's of SaaS Pricing pages</v-card-title>
            <v-spacer></v-spacer>
            <v-card-subtitle class="subtitle-1">Powerfully analyze the pricing pages of thousands of SaaS
              companies globally</v-card-subtitle>
            <v-form @submit.prevent="validate" ref="form" lazy-validation>
              <v-card-text>
                <p>
                  <v-icon color="green accent-4">mdi-bookmark-check</v-icon>Unlimted lifetime access with regular
                  monthly updates
                </p>
                <p>
                  <v-icon color="green accent-4">mdi-bookmark-check</v-icon>Track your market's pricing without lifting
                  a finger
                </p>
                <p>
                  <v-icon color="green accent-4">mdi-bookmark-check</v-icon>Plan
                  your pricing changes using real world data
                </p>
                <p>
                  <v-text-field label="Email Address" :rules="emailRules" v-model="registrationEmail"></v-text-field>
                  <card class="stripe-card" :class="{ complete }" :stripe="apiKey" :options="stripeOptions"
                    @change="complete = $event.complete"></card>
                </p>
                <div class="red--text text--darken-1">{{ stripeErr }}</div>
                <span v-if="error">
                  <strong class="red--text">{{ errorText }}</strong>
                </span>
              </v-card-text>
              <v-card-actions>
                <v-btn color="red darken-1" outlined @click="dialog = false">Cancel</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="green accent-4" dark type="submit">Pay $299</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-dialog>
      </v-row>

    </div>
  </div>
</template>

<script>
import { Card, createToken } from "vue-stripe-elements-plus";
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import Navigation from "@/components/Navigation";
import FilterBar from "@/components/FilterBar";
import SearchInput from "@/components/SearchInput";
import VueCookies from 'vue-cookies';

Vue.use(VueAxios, axios);
Vue.use(VueCookies);

axios.defaults.baseURL = process.env.VUE_APP_BASEAPI;

export default {
  name: "PricingTableSmall",
  components: { Card, Navigation, FilterBar, SearchInput },
  data: () => ({
    error: false,
    errorText: "",
    emailRules: [
      v => !!v || "Please enter your email address",
      v =>
        /.+@.+\..+/.test(v) || "This doesn't appear to be a valid email address"
    ],
    complete: false,
    stripeErr: "",
    stripeOptions: {
      hidePostalCode: true
    },
    registrationEmail: "",
    productId: process.env.VUE_APP_PRODUCT_ID,
    apiKey: process.env.VUE_APP_STRIPE_API_KEY,
    source: null,
    dialog: false,
    priceMenu: false,
    ctaMenu: false,
    cta: "",
    planName: "",
    companyName: "",
    search: "",
    defaultPriceRange: [0, 990],
    defaultPriceMax: 990,
    realMaxPrice: 0,
    defaultPriceMin: 0,
    filteredItems: 0,
    pricing: [],
    stats: {},
    companies: {},
    ctas: [],
    showPriceRange: false,
    showCompanies: false,
    showCtas: false,
    showPlansLargerThan1000: false,
    showTrialPlans: false,
    showEnterprisePlans: false,
    showPerUserPlans: false,
    showSlidingPlans: false,
    showMoneyBackPlans: false,
    showHeroPlans: false,
    currency: {
      USD: "$",
      EUR: "€",
      GBP: "£",
      INR: "₹",
      ISK: "kr",
      RON: "lei"
    },
    selectedCompanies: [],
    selectedCtas: [],
    amounts: [],
    amountsSmall: [],
    visibleAmounts: [],
    showDetails: false,
    curCompany: {
      company: {}
    },
    curPlans: {},
    curPlansCount: 0,
    curDirectories: [],
    months: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    isMobileFilter: false,
    showFilterButton: false,
    sortColumn: 'company.name',
    sortDesc: false,
    loggedIn: false,
  }),
  mounted() {
    this.checkPaymentAndLoad();
    // console.log(this.headers);
  },
  updated() {
    this.getFilteredCount();
  },
  computed: {
    latestImageDomain() {
      return process.env.VUE_APP_SCREENSHOTSURL + "latest/";
    },
    baseImageDomain() {
      return process.env.VUE_APP_SCREENSHOTSURL;
    },
    headers() {
      return [
        {
          text: "Companies",
          align: 'center',
          width: "120px",
          sortable: true,
          value: "company.name",
          filter: value => {
            if (!this.companyName) return true;
            return value.toUpperCase().includes(this.companyName.toUpperCase());
          }
        },
        {
          text: "Plan Name",
          align: 'center',
          value: "plan_name",
          width: "120px",
          filter: value => {
            if (!this.planName) return true;
            return value.toUpperCase().includes(this.planName.toUpperCase());
          }
        },
        {
          text: "Pricing",
          value: "default_price",
          align: 'center',
          width: "60px",
          filter: value => {
            return (
              value > this.defaultPriceRange[0] &&
              value < this.defaultPriceRange[1]
            );
          }
        },
        {
          text: "Billing cycle",
          value: "default_period",
          align: 'center',
          width: "60px"
        },
        {
          text: "Trial Length",
          align: 'center',
          value: "length_of_trial",
          width: "60px",
          filter: value => {
            if (!this.showTrialPlans) return true;
            return value != "";
          }
        },
        {
          text: "Call To Action",
          align: 'center',
          value: "call_to_action",
          width: "160px",
          filter: value => {
            if (this.selectedCtas.length == this.ctas.length) return true;
            return this.selectedCtas.includes(value);
          }
        },

        // { text: "Secondary Pricing", width: "80px", value: "secondary_price" },
        // {
        //   text: "secondary Billing cycle",
        //   value: "secondary_period",
        //   width: "60px"
        // },
        // {
        //   text: "Trial Length",
        //   value: "trial_period",
        //   width: "40px"
        // },
        {
          text: "Currency",
          align: 'center',
          value: "currency",
          width: "30px"
        },
        // {
        //   text: "Reviews",
        //   align: 'center',
        //   value: "reviews",
        //   width: "30px"
        // },
        // {
        //   text: "Category",
        //   align: 'center',
        //   value: "category",
        //   width: "60px"
        // },
        {
          text: "Per User Pricing",
          align: 'center',
          value: "per_user_pricing",
          filter: value => {
            if (!this.showPerUserPlans) return true;
            return value != false;
          }
        },
        {
          text: "Sliding Pricing Scale",
          align: 'center',
          value: "sliding_scale_pricing",
          filter: value => {
            if (!this.showSlidingPlans) return true;
            return value != false;
          }
        },
        {
          text: "Enterprise",
          align: 'center',
          value: "enterprise",
          filter: value => {
            if (!this.showEnterprisePlans) return true;
            return value != false;
          }
        },
        {
          text: "Hero Plan",
          align: 'center',
          value: "hero",
          filter: value => {
            if (!this.showHeroPlans) return true;
            return value != false;
          }
        },
        {
          text: "Money Back Guarantee",
          align: 'center',
          value: "money_back_guarantee",
          filter: value => {
            if (!this.showMoneyBackPlans) return true;
            return value != false;
          }
        }
      ];
    },
    showFreePlans() {
      return this.$store.getters.free;
    }
  },
  watch: {
    showPlansLargerThan1000() {
      if (this.showPlansLargerThan1000) {
        this.defaultPriceMax = this.realMaxPrice;
        this.defaultPriceRange[(this.defaultPriceRange, this.defaultPriceMax)];
        this.visibleAmounts = this.amounts;
      } else {
        this.defaultPriceMax = 990;
        this.defaultPriceRange[(this.defaultPriceRange, 990)];
        this.visibleAmounts = this.amountsSmall;
      }
    },
    currencies: {
      deep: true,
      handler: function (value) {
        console.log(value);
      }
    }
  },
  created() {
    window.addEventListener("resize", this.getMobileState);
    if(this.$cookies.get('detailsCount') == null) {
      this.$cookies.set('detailsCount', 0, -1);
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.getMobileState);
  },
  methods: {
    setIconLoaded(item) {
      Vue.set(this.pricing, this.pricing.map(function (x) { return x.id; }).indexOf(item.id), true);
    },
    getLogo(company) {
      // console.log(e);
      Vue.axios
        .get('https://logo.clearbit.com/' + company.domain + '?size=22')
        .then(() => {
          return 'https://logo.clearbit.com/' + company.domain + '?size=22';
        })
        .catch(() => {
          return "@/assets/dummy_logo.png";
        });
      // return "@/assets/dummy_logo.png";
    },
    checkPaymentAndLoad() {
      // console.log('hash ', this.$route.params.hash);
      this.loggedIn = false;
      if (typeof (this.$route.params.hash) == 'undefined') {
        // this.enableConversionPopup();
        // this.loadFree();
        this.$store.dispatch("retrieveUserDetails")
          .then(() => {
            console.log('retrieveUserDetails');
            if (this.$store.getters.hash && this.$store.getters.hash != '') {
              console.log('here');
              const url = new URL(`/pro/${this.$store.getters.hash}`, window.location.origin)
              window.location.href = url.toString()
            } else {
              console.log('free');
              this.loadFree();
              return;
            }
          })
          .catch(error => {
            console.log(error);
          });
        this.loadFree();
        return;
      }
      Vue.axios
        .post("getemail", {
          hash: this.$route.params.hash
        })
        .then(response => {
          if (response.data.status == "success") {
            this.loggedIn = true;
            this.$store
              .dispatch("retrieveToken", {
                hash: this.$route.params.hash,
              })
              .then(() => {
                this.$store.dispatch("retrieveUserDetails")
                  .then(() => {
                    this.loadPro();
                  })
                  .catch(error => {
                    console.log(error);
                  });
              })
              .catch(error => {
                console.log(error);
              });
          } else {
            this.loadFree();
          }
        })
        .catch(() => {
          // console.log(error);
          this.loadFree();
        });
    },
    loadFree() {
      this.getPricing();
      this.getStats();
      this.getCompanies();
      this.getCtas();
      this.getMobileState();
    },
    loadPro() {
      // this.getUserData();
      this.getPricingPro();
      this.getStats();
      this.getCompaniesPro();
      this.getCtasPro();
    },
    getMobileState() {
      if (window.innerWidth < 768) {
        this.showFilterButton = true;
      } else {
        this.showFilterButton = false;
      }
    },
    handleSort(event) {
      console.log('>>', event);
      if (event == 'A-Z') {
        this.sortColumn = 'company.name';
        this.sortDesc = false;
      } else if (event == 'Z-A') {
        this.sortColumn = 'company.name';
        this.sortDesc = true;
      } else if (event == 'Lowest price') {
        this.sortColumn = 'default_price';
        this.sortDesc = false;
      } else if (event == 'Highest price') {
        this.sortColumn = 'default_price';
        this.sortDesc = true;
      } else if (event == 'Shortest trial') {
        this.sortColumn = 'length_of_trial';
        this.sortDesc = false;
      } else if (event == 'Longest trial') {
        this.sortColumn = 'length_of_trial';
        this.sortDesc = true;
      }
    },
    handleSearch(event) {
      // console.log(event);
      this.companyName = event;
    },
    rowClick(rowName) {
      var name = rowName.replace(/\s/g, "_");
      let routeData = this.$router.resolve({ path: `/${name}` });
      if (this.loggedIn) {
        routeData = this.$router.resolve({ path: `/${name}/${this.$store.getters.hash}` });
      }
      window.open(routeData.href, "_blank");
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.pay();
      }
    },
    pay() {
      // createToken returns a Promise which resolves in a result object with
      // either a token or an error key.
      // See https://stripe.com/docs/api#tokens for the token object.
      // See https://stripe.com/docs/api#errors for the error object.
      // More general https://stripe.com/docs/stripe.js#stripe-create-token.
      createToken().then(data => {
        if ("error" in data) {
          this.stripeErr = data.error.message;
        }
        if ("token" in data) {
          // console.log(data.token);
          this.stripeErr = "";
          Vue.axios
            .post("checkout", {
              stripeToken: data.token.id,
              email: this.registrationEmail
            })
            .then(() => {
              this.$store
                .dispatch("retrieveToken", {
                  username: this.registrationEmail,
                  password: this.registrationEmail
                })
                .then(() => {
                  this.$store.dispatch("retrieveUserDetails").then(() => {
                    this.$router.push({
                      path: "/pro/" + this.$store.getters.hash
                    });
                    //a7b39d863481e35310d478b6491e56d6091bf082
                  });
                })
                .catch(error => {
                  this.error = true;
                  this.errorText = error.response.data.message;
                });
            })
            .catch(error => {
              console.log(error);
              this.stripeErr =
                "Unable to process payment. " + error.response.data.message;
            });
        }
      });
    },
    toggleCta(index, cta, value) {
      console.log(cta + " : " + value);
      var newCta = {
        created_at: this.ctas[index].created_at,
        cta: this.ctas[index].cta,
        id: this.ctas[index].id,
        selected: !this.ctas[index].selected,
        updated_at: this.ctas[index].updated_at
      };
      this.$set(this.ctas, index, newCta);
      // this.ctas.$set(index.selected = !this.ctas[index].selected;
    },
    getUserData() {
      this.$store.dispatch("retrieveUserDetails").then(() => {
        this.showSuccess = this.$store.getters.user.tooltip;
      });
    },
    getPricingPro() {
      if (this.pricing == "undefined" || this.pricing.length < 1) {
        this.$store.dispatch("retrievePricingPro").then(() => {
          this.pricing = this.$store.getters.pricing;
        });
      }
    },
    getPricing() {
      if (this.pricing == "undefined" || this.pricing.length < 1) {
        this.$store.dispatch("retrievePricing").then(() => {
          this.pricing = this.$store.getters.pricing;
          // this.sortColumn = 'Companies';
        });
      }
    },
    setShowCompany() {
      var companyId = -1;
      this.pricing.forEach((item, index) => {
        if (item.company_id != companyId) {
          this.$set(this.showCompany, index, true);
        } else {
          this.$set(this.showCompany, index, false);
        }
        companyId = item.company_id;
      });
    },
    getFilteredCount() {
      if (this.$refs.refName !== "undefined") {
        this.filteredItems = this.$refs.refName.items.length;
      } else {
        this.filteredItems = 0;
      }
    },
    getStats() {
      this.$store.dispatch("retrieveStats").then(() => {
        this.stats = this.$store.getters.stats;
        this.realMaxPrice = this.stats.max_price;
        this.defaultPriceMin = this.stats.min_price;
        this.amounts = Object.values(this.stats.amounts);
        this.amountsSmall = Object.values(this.stats.amountsSmall);
        this.visibleAmounts = this.amountsSmall;
      });
    },
    getCompaniesPro() {
      this.$store.dispatch("retrieveCompaniesPro").then(() => {
        this.companies = this.$store.getters.companies;
        for (var key in this.companies) {
          this.selectedCompanies.push(this.companies[key]);
        }
      });
    },
    getCompanies() {
      this.$store.dispatch("retrieveCompanies").then(() => {
        this.companies = this.$store.getters.companies;
        for (var key in this.companies) {
          this.selectedCompanies.push(this.companies[key]);
        }
      });
    },
    getCtasPro() {
      this.$store.dispatch("retrieveCtasPro").then(() => {
        this.ctas = this.$store.getters.ctas;
        for (var key in this.ctas) {
          this.selectedCtas.push(this.ctas[key].cta);
        }
      });
    },
    getCtas() {
      this.$store.dispatch("retrieveCtas").then(() => {
        this.ctas = this.$store.getters.ctas;
        for (var key in this.ctas) {
          this.selectedCtas.push(this.ctas[key].cta);
        }
      });
    },
    getPeriod(period) {
      switch (period) {
        case "Monthly":
          return "month";
        case "Annually":
          return "year";
        case "Quarterly":
          return "quarter";
        default:
          return period;
      }
    },
    showPriceRangePopover() {
      this.showPriceRange = !this.showPriceRange;
    },
    showCompaniesPopover() {
      console.log(this.selectedCompanies);
      this.showCompanies = !this.showCompanies;
    },
    showCtasPopover() {
      this.showCtas = !this.showCtas;
    },
    handleIconFilterClicked() {
      this.isMobileFilter = !this.isMobileFilter;
    },
    handleIconCloseClicked() {
      this.isMobileFilter = false;
    }
  }
};
</script>

<style>
.main-data-table .v-data-table__wrapper {
  overflow-x: scroll !important;
  /* max-height: 100%; */
}

.main-data-table .v-data-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: white;
}

.main-data-table .v-data-table__wrapper {
  margin-bottom: 60px;
}

.main-data-table .v-data-table__wrapper::-webkit-scrollbar {
  width: 7px;
  background: transparent;
}

.main-data-table .v-data-table__wrapper::-webkit-scrollbar-thumb {
  border-radius: 4px;
    background-color: rgba(0,0,0,.5);
    -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
}

.v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
  font-size: 12px !important;
  font-weight: 400 !important;
}
.search-bar__search-input {
  display: flex;
  flex-direction: row;
}

.search-bar__search-input-input {
  flex-grow: 1;
}

.search-bar__search-input-filter {
  /* position: relative; */
  top: 1px;
}

.theme--light.v-data-table thead tr th {
  color: #222049;
  font-weight: 500;
}

table tbody tr,
table tbody tr:nth-of-type(odd) {
  background-color: transparent !important;
}

table thead th {
  border-bottom: solid 1px #ebebef !important;
}

.v-application table tbody .subtitle-2 {
  color: #222049;
  font-weight: 600 !important;
  font-size: 12px !important;
}

.v-application table tbody .subtitle-3 {
  color: #4a4a53;
  font-weight: 400;
  font-size: 12px !important;
}

.theme--light.v-chip:not(.v-chip--active) {
  background: #e6f7ee;
  color: #222049;
  font-weight: 600 !important;
}
</style>
